/* eslint-disable multiline-comment-style */
import { floor } from 'lodash-es'
import qs from 'qs'
import { createPolling } from './polling'
import { downloadFile } from './download'
import { useSize } from 'ahooks'
import { failToast } from './toast'
import { HOSTS } from './env'

// 时间number转化为时分格式
const timeNumber2HmString = (value: number) => {
  // eslint-disable-next-line @sailor/i18n-no-day-seconds
  const num = value / 3600
  const hour = floor(num)
  const minute = floor((num - hour) * 60)
  return `${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute}`
}

const safeParse = (val:string, defaultValue: any) => {
  try {
    return JSON.parse(val)
  } catch (e) {
    return defaultValue
  }
}

export const getQueryValues = (key?:string) => {
  const searchStr = location.search
  if (!searchStr) return key === undefined ? {} : ''
  const search = { ...qs.parse(searchStr, { ignoreQueryPrefix: true }), ...getHashQuery() }
  if (key) return search[key]
  return key === undefined ? search : search[key]
}

export function getHashQuery<T extends {[k: string]: any}> (): T {
  const query = qs.parse(window.location.hash.split('?')[1]) as unknown as T
  return query
}

export function isEqualString (param1: number | string | undefined, param2: number | string | undefined) {
  return String(param1) === String(param2)
}

export function useTableScrollHeight () {
  const wraper = document.querySelector('.roo-tableNew-wrapper')
  const wraperSize = useSize(wraper)
  const header = document.querySelector('.roo-tableNew-header')?.clientHeight || 0
  const pagination = (document.querySelector('.roo-pagination')?.clientHeight || 52) + 20 // 分页信息不一定能加载出来,默认值给52. 20为margin

  return (wraperSize?.height || 0) - header - pagination - 5
}

export function getEmailName (email = '') {
  const name = email?.split('@')[0]
  return name ? `(${name})` : ''
}

export function getNumStr (val?: number) {
  if (val === undefined || val === null) return undefined
  return String(val)
}


export function onFormCheckFail (errorInfo: any) {
  try {
    const errorMsg = errorInfo.errorFields[0].errors[0]
    failToast(errorMsg)
  } catch (error) {
    console.log('Failed:', errorInfo)
  }
}

export function jumpYodaVerify (requestCode: string) {
  // 接入文档: https://km.sankuai.com/collabpage/1451014511#b-da966dcba7174a54a04585f896dec95a
  // 模白名单 :https://risklist-oversea.canyinrc.test.sankuai.com/#/listAccountDataManage
  const params = [
    `requestCode=${requestCode}`,                   // 必需参数，外网请求验证中心服务的凭证 (有效期10分钟)
    `succCallbackUrl=${encodeURIComponent(window.location.href)}`, // 成功回调页面。仅限web端 Yoda验证成功跳转 建议使用encodeURIComponent做url编码 必须*.meituan.com、*.dianping.com、*.sankuai.com(特殊域名联系Yoda对接人进行配置)
    // 'failCallbackUrl='+encodeURIComponent('https://www.meituan.com'),  //失败回调页面。仅限web端 Yoda验证失败跳转 建议使用encodeURIComponent做url编码 必须*.meituan.com、*.dianping.com、*.sankuai.com
    // `succCallbackKNBFun=${YODA_VERIFY_FN_NAME}`, // 仅限knb容器打开H5使用，可以通过KNB.subscribe订阅结果。
    // 'yodaCommonThemeColor='+encodeURIComponent('#ffe41f'),  //可选 1）主题色配置 常态按钮 87%  2）按压态按钮 100%  3）不可点击态按钮 60%  4）链接 87%  5）logo 87%  6）icon图片 87% 可以理解为是主题色值 仅支持 #AABBCC 格式
    // 'yodaButtonTextColor='+encodeURIComponent('#222222'),      //可选 1）按钮文字颜色  仅支持 #AABBCC 格式
  ]

  window.location.href = `${HOSTS.YODA}/v2/app/general_page?${params.join('&')}` // i版&移动端-app pc&桌面端-web
}


export {
  timeNumber2HmString,
  safeParse,
  createPolling,
  downloadFile,
}


